module.exports = __webpack_public_path__ + "static/media/option11-4row.c65b8ab7.png";